import { TypeBackgroundColors } from "../constants.js";
import { useMemo } from "react";
import { RichTextEditorDisplayContent, Tag } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { getFormattedRelativeDate } from "@therms/web-js";
//#region src/modules/SystemInfo/shared/components/Post.tsx
function Post({ body, bodyHtml, excerpt, timestamp, title, type }) {
	const _body = bodyHtml ? /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: bodyHtml } }) : body;
	const formattedDate = useMemo(() => {
		if (!timestamp) return "";
		return getFormattedRelativeDate(timestamp);
	}, [timestamp]);
	return /* @__PURE__ */ jsxs(RichTextEditorDisplayContent, {
		className: "mx-auto max-w-prose",
		children: [
			(!!formattedDate || !!type) && /* @__PURE__ */ jsxs("div", {
				className: "space-x-xs",
				children: [!!formattedDate && /* @__PURE__ */ jsx("span", {
					className: "mb-xs text-color-subtle text-sm font-bold uppercase",
					children: formattedDate
				}), !!type && /* @__PURE__ */ jsx(Tag, {
					value: type,
					backgroundColor: TypeBackgroundColors[type],
					textColor: "var(--color-text)"
				})]
			}),
			!!title && /* @__PURE__ */ jsx("h1", {
				className: "mb-xs text-xl font-bold",
				children: title
			}),
			!!title && /* @__PURE__ */ jsx("h1", {
				className: "mb-base text-color-subtle text-sm font-bold",
				children: excerpt
			}),
			_body
		]
	});
}
//#endregion
export { Post };

//# sourceMappingURL=Post.js.map